// extracted by mini-css-extract-plugin
export var notificationHost = "_cf-0";